export default __webpack_public_path__ + "static/media/essaylist.5948c344.png";